import type { Icons } from '@Components/icon/Icon';
import type { OnboardingFormFields } from '@Types/index.ts';
import type { REVIEW_BLOCK_TYPES } from '@Pages/happyFlowPages/reviewPage/types';
import type { ReactElement } from 'react';
type EnumToInterface<T extends object> = { [K in keyof T]: string };

export type FormFieldErrors = EnumToInterface<typeof OnboardingFormFields>;

export interface ReviewBlockError {
  hasError: boolean;
  message?: string;
}

export type ReviewBlockErrors = {
  [key in REVIEW_BLOCK_TYPES]?: ReviewBlockError;
};

export interface IErrorSlice {
  errorSlice: {
    formFieldErrors: FormFieldErrors;
    reviewBlockErrors: ReviewBlockErrors;
    errorModal: {
      error: string;
      modalProps?: IErrorModalProps;
    };
    isNameTooLongModalShown: boolean;
    setFormFieldError: (field: keyof FormFieldErrors, error: string) => void;
    setReviewBlockError: (blockType: REVIEW_BLOCK_TYPES, message?: string) => void;
    clearReviewBlockError: (blockType: REVIEW_BLOCK_TYPES) => void;
    resetReviewBlockErrors: () => void;
    setErrorModal: (data: { error: string; modalProps?: IErrorModalProps }) => void;
    setIsNameTooLongModalShown: (isShown: boolean) => void;
    resetFormFieldErrors: () => void;
  };
}

export enum ErrorModalTypes {
  GENERAL = 'general',
  CUSTOM = 'custom',
}
export interface IErrorModalProps {
  title?: string;
  shouldPersist?: boolean;
  content?: string;
  icon?: Icons;
  buttonText?: string;
  button2Text?: string;
  type: ErrorModalTypes | undefined;
  onSubmit?: () => void;
  onCancel?: () => void;
  cmp?: () => ReactElement;
}
